import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    workflowRepository
} from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import ClientDataProvider from "../External/ClientDataProvider/ClientDataProvider";
import { SetRootNodeAsync } from "./SetRootNode";

export async function GotoParentAsync(rootNode: IWorkflowNode) {
    const parentNode = await WithAnimatedProgressBarAsync(() =>
        workflowRepository.GetParentNodeAsync(ClientDataProvider, rootNode)
    );

    if (!parentNode) {
        return;
    }

    SetRootNodeAsync(parentNode.id);
}

export async function GotoNodeAsync(name: string) {
    const node = await workflowRepository.GetNodeByNameAsync(
        ClientDataProvider,
        name
    );

    if (node) {
        SetRootNodeAsync(node.id);
    }
}
